import { useEffect, useState } from "react";
import instance from "../../../WebApi/WebApi";
const useUnitData = () => {
  const [unitData, setUnitData] = useState();

  useEffect(() => {
    getUnitData();
  }, []);
  const getUnitData = async () => {
    const url = `/customer/common/list-unit-measure`;
    try {
      const response = await instance.get(url);

      // Remove deleted units
      let filteredUnits = response.data.data.filter(unit => !unit.is_delete);

      setUnitData(filteredUnits);

    } catch (err) {
      console.log(err);
    }
  };

  return unitData;
};

export default useUnitData;
